//首页
//1.导航栏
export const navItems = [
  { title: 'Home', details: [] },
  { title: 'About CIMDR', details: [] },
  { title: 'CIMDR2021', details: [] },
  { title: 'News', details: [] },
  // { title: 'CIMDR Exclusive Memory', details: [] },
  { title: 'Download', details: [] },
  { title: 'Review', details: ['2016CIMDR', '2017CIMDR', '2018CIMDR', '2019CIMDR','2020CIMDR'] },
  { title: 'Contact us', details: [] }
];
//2.0
export const AboutCimdr = 'About CIMDR'
export const Review = 'Review'
export const review = 'Review'
export const ReviewDetail = ['2016CIMDR', '2017CIMDR', '2018CIMDR', '2019CIMDR','2020CIMDR']
export const News = 'News'
export const Download = 'Download'
export const More = 'More'
export const ContactUs = 'ContactUs'
//3.0 登录完成后
export const loginDeclare = 'Login declare'
export const signUp = 'Sign Up'
export const logout = 'logout'
//4.登录
export const login = {
  title: '11th China International Medical',
  detail: 'Device Regulatory Forum',
  phoneHolder: 'Please enter email',
  pwdHolder: 'Please enter password',
  register: 'Registration',
  forgetPwd: 'Forget Password',
  login: 'Login'
}


//3.0 子导航
export const navItemsChild = [
  { title: 'Home', details: [] },
  { title: 'News', details: [] }, // { id: 999, name: 'Preparatory meeting' }
  { title: 'Forum Information', details: [{ id: 1439, name: 'Basic Information' }, { id: 1440, name: 'Forum Notice' }, { id: 1441, name: 'Traffic Information' }, { id: 1442, name: 'Accommodation' }] },
  { title: 'Agenda', details: [] },
  { title: 'Contact us', details: [] },
  { title: 'Registration', details: [] },
  { title: 'Download', details: [] },
  // { title: 'Live Broadcast', details: [{ id: 101, name: 'CIMDR' }, { id: 102, name: 'MD50 / RA' }] }
];

export const ForumInformation = 'Forum Information'
export const Agenda = 'Agenda'
export const Registration = 'Registration'

export const MeetingIng_Info_id = "999"
export const BaseInfo_Info_id = "1439"
export const MeetingManage_Info_id = "1440"
export const TrainInfo_Info_id = "1441"
export const HotelInfo_Info_id = "992"

export const Registration_Info_id = "1445"

// 联系我们ID
export const Contact_info_Id = '1443'
// 关于CIMDR
export const About_info_id = '1431'


//会议日期
export const ForumDateTitleFirst = '12th China International Medical'
export const ForumDateTitleSecond = 'Device Regulatory Forum'
export const ForumDate = [
  { title: 'Date of CIMDR', detail: 'September 23-26, 2021' },
  { title: 'Early bird registration deadline', detail: 'August 20, 2021' },
  { title: 'Online registration deadline', detail: 'September 26, 2021' },
  { title: 'Date of on-site registration', detail: 'September 23, 2021' }
];

//HomeFoot
export const footer = {
  public: 'National Medical Products Administration (NMPA)China Center for Food and Drug International Exchange (CCFDIE) All rights reserved.',
  address: ' Room 1106, 11th Floor, Office Building B, Maple International Center, No. 32, Xizhimen North Street, Haidian District, Beijing, 100082, P.R.C',
  telAndPostcodeAndFax: ' Tel:010-82212866 PostCode:100082 Fax:010-82212857',
  tel: ' 010-82212866',
  code: ' 100082',
  fax: ' 010-82212857',
  web: ' Web:',
  record: ' Record number:Beijing ICP 15042885-1',
  technicalSupport: ' Supported By Medcircle',
  keyaddress: 'Address:',
  keyphone: 'Telephone:',
  keyfax: 'Fax:',
  keyWebsite: 'Website:',
  keyzipcode: 'Zip code:',
}

//新闻动态 为空／文字显示
export const noInfo = 'No information,please to be continued!'


export const noOpen = 'Not open！'

export const accessFailed = 'Access failed, please try again later'

export const AccountOrPwdError = 'Account/password error'

export const AccountNotRegister = 'The account is not registered. Please log in after registration!'

export const correntPhoneAdnPhone = 'Please enter the correct phone/email!'

export const lessPwd = "The password can't be less than 6 bits!"

export const phoneAndEmailNon = "phone/email can't be empty!"

export const pwdNon = "password can't be empty"

//register注册
export const userRegister = 'Register'
export const backHome = 'Back Home'

export const EmailTitle = 'Email'
export const TelPhoneTitle = 'Mobile Number'
export const PWD = 'Password'
export const ConfirmPWD = 'Confirm Password'
export const Name = 'Name'
export const NameFirst = 'Family Name'
export const NameLast = 'First Name'
export const Sex = 'Gender'
export const SexBoys = 'Male'
export const SexGirls = 'Female'

export const Country = 'Country'
export const CityOrState = 'City/State'
export const StreetAddress = 'Street Address'
export const Company = 'Institution/Company'
export const Position = 'Position'

export const enterEmail = 'Please enter your email'
export const enterTelPhone = 'Please enter your mobile number'
export const enterPWD = 'Please enter your password(at least 6 digits)'
export const enterConfirmPWD = 'Please enter your confirm password'
export const enterName = 'Please enter your name'
export const enterNameFirst = 'Family Name'
export const enterNameLast = 'First Name'

export const enterCountry = 'Please enter your Country'
export const enterCityOrState = 'Please enter your City/State'
export const enterStreetAddress = 'Please enter your Street Address'
export const enterCompany = 'Please enter your Institution/Company'
export const enterPosition = 'Please enter your Position'

export const enterAddress = 'Address'
export const vericationAddress = 'Address can\'t be empty!'
export const regAddress = 'Please enter your address'

export const enterMyphone = 'phone'
export const regMyphone = 'Please enter your phone number'
export const vericationMyphone = 'Phone can\'t be empty!'

export const Unit = 'Org'
export const enterUnit = 'Please enter your Org'
export const unitNotNull = 'Org can\'t be empty'

export const enterMyEmail = 'Eamil'
export const regMyEmail = 'Please enter your email'
export const vericationMyEmail1 = 'email can\'t be empty'
export const vericationMyEmail2 = 'Please input the correct email'

export const picture = 'Photo'
export const uploadImage = 'upload photos'
export const pictureDesc = 'Photo description'
export const enterPictureDesc = 'Please enter your photo description'
export const mysubmit = 'submit'
export const memory = 'CIMDR Exclusive Memory'
export const amend = ' To Amend'
export const participation = 'Participation'
export const notices = 'format：JPG/JPEG, size：1~10M，amount：At most five'



//忘记注册

export const RegEmail = 'Email'
export const RegVericationCode = 'Verication Code'
export const RegPassword = 'New password'
export const RegComfirmPassword = 'Confirm Password'
export const RegGetVerficationCode = 'Get verfication code'
export const RegPhoneFindPWD = 'Get the password back by phone number'
export const RegEmailFindPWD = 'Get the password back by email'
export const getBack = 's get it back'

export const enterRegEmail = 'Email'
export const enterRegPhoneNumber = 'Please enter your phone number'
export const enterRegVericationCode = 'Verication Code'
export const enterRegPassword = 'Password'
export const enterRegComfirmPassword = 'Comfirm Password'

export const enterFindPWD = 'Forget Password'

export const vericationNotNull = "verification code can't be empty"
export const vericationUnFormat = 'Please input the correct verification code'

export const changePWDSucceed = 'Revise the password successfully'
export const phoneNotRegistered = 'The phone number is not yet registered!'
export const vercodeInvalid = 'Verification code is invalid!'
export const emailNotRegistered = 'Email is not yet registered!'
export const compeletedPerson = 'Please perfect the information'
export const vericationSend = 'The verification code has been sent!'
export const findPWDFailture = 'Failed to retrieve the password'

export const emailNotNull = "email can't be empty";
export const emailUnFormat = 'Please input the correct email';
export const mobilNotNull = "mobile number can't be empty";
export const mobilUnFormat = "Please input the correct mobile number";
export const passwordNotNull = "password can't be empty";
export const passwordAtLeastSix = 'password is between 6 and 20 digits';
export const confirmUnFormat = 'The second password is incons';
export const nameNotNull = "name can't be empty";
export const nameFisrtNotNull = "family name can't be empty";
export const nameFisrtUnFormat = "please input the correct family name";
export const nameLastNotNull = "first name can't be empty";
export const nameLastUnFormat = "please input the correct first name";

// export const country='country'
// export const enterCountry='please enter Country'
//
// export const state='City/State'
// export const enterState='please enter City/State'
//
// export const streetAddress='Street Address'
// export const enterstreetAddress='please enter your Street Address'
//
// export const company='Institution/Company'
// export const entercompany='please enter Institution/Company'
//
// export const position='Position'
// export const enterposition='please enter your position'

export const countryNotNull = "country can't be empty"
export const cityNotNull = "city/state can't be empty"
export const stressNotNull = "stress address can't be empty"
export const companyNotNull = "Institution/company can't be empty"
export const positionNotNull = "position can't be empty"
// export const positionNotNullEn="position can't be empty"

export const submit = 'submit'

export const congratulation = 'Congratulations, the registration is successful!';
export const haslogin = 'Your phone number or mailbox has been registered. Please log in directly';
export const improveInformation = 'Please improve personal information!'


//登录说明
export const noteDate = 'September 23-26, 2021'
export const notePlace = 'China Optics Valley Convention & Exhibition Center Wuhan · China'
export const note1 = "Ⅰ. Click “Registration”and enter your user information, a confirmation letter of account info will be sent to you via email from secretariat after successful registration."
export const note2 = 'Ⅱ. After registering or logging in, click “I want to sign up”to formally register, research hotel room reservation online.'
export const note3 = 'Ⅲ.After completing the online payment, a payment confirmation email from secretariat will be sent to you.\n'
export const note4 = 'Note: Please remember your username and password, if you need log in again or modify your personal information, please log in directly using the registered username and password.'

export const notice = 'Notice'

export const ok = 'ok'

export const banner = '../../assets/img/bannerEn.png'

export const locale = 'en'

export const modulError = 'Error'
export const modulWarn = 'Warning'
export const modulTips = 'Tips'
export const modulSure = 'OK'
export const modulCancel = 'Cancel'

export const modulDel = 'Do you confirm the deletion？'
export const modulGolgoin = 'Please go to the home page to login'
export const modulIpImg = 'Please upload photos.'
export const modulInfo = 'Please improve the information.'
export const modulIUpNum = 'Upload up to 5 pictures.'

export const modulIUpsize = 'Image size is 1~10M, please re-select the files.'



//////////////////
// WEBPACK FOOTER
// ./static/js/en.js
// module id = U6mz
// module chunks = 12